import React, { Component } from "react";
import Header from "../component/Header";
import Breadcrumb from "../component/Breadcumb";

import aboutus from "../assets/img/Jainism/aboutusnew12.png"
import guruji from "../assets/img/Jainism/guruji.png"
import aboutusvector from "../assets/img/Jainism/aboutimg.svg"
import bluelotus from "../assets/img/Jainism/blue lotus.png"
import star from "../assets/img/icon/star-10.png"
import counter3 from "../assets/img/icon/counter-3.png"
import counter4 from "../assets/img/icon/counter-4.png"
import counter from "../assets/img/icon/counter-1.png"
import counterbefore from "../assets/img/shape/counter-before-1.png"
import counterafter from "../assets/img/shape/counter-after-1.png"
import aboutus1 from "../assets/img/Jainism/aboutus1.png"
import bookfooter from "../assets/img/Jainism/bookfooter.png"
import prayingboy from "../assets/img/Jainism/praying_boy.png"
import blassedguruji from "../assets/img/Jainism/blassed_guruji.png"
import Footer from "../component/Footer";
import { BASEURL } from "../../Global";


class AboutUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            themeSetting: [],
        };
    }
    componentDidMount() {
        document.title = "About Us - My Jainism";

        this.counterUp('.counter-number', 10, 1000);
        this.fetchThemeSetting()
    }

    counterUp(selector, delay, duration) {
        const counters = document.querySelectorAll(selector);

        counters.forEach(counter => {
            const updateCount = () => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.innerText;
                const increment = target / (duration / delay);

                if (count < target) {
                    counter.innerText = Math.ceil(count + increment);
                    setTimeout(updateCount, delay);
                } else {
                    counter.innerText = target;
                }
            };

            updateCount();
        });
    }
    async fetchThemeSetting() {
        try {
            await fetch(`${BASEURL}/themesettingswithoutauth`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ themeSetting: responseJson.data[0] })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    render() {
        return (
            <React.Fragment>
                <title>About - My Jainism</title>
                <Header />
                <Breadcrumb title={"About Us"} />
                <section className="about-section space">
                    <div className="container">
                        <div className="row align-items-center gy-30">
                            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
                                <div className="img-box-2 ">
                                    <img src={aboutus} alt="photo" className="big-img" />
                                    <img src={aboutusvector} alt="photo" className="small-img" />
                                </div>
                            </div>
                            <div className="col-lg-5 wow fadeInRight" data-wow-delay="0.1s">
                                <div className="text-center text-lg-start">
                                    <span className="sub-title">About</span>
                                    <h2 className="sec-title big-title">My Jainism</h2>
                                    <p className="fs-md mb-30">“My Jainism” - Ek Sanskar Mandir is a non-profit organization who is working to imbibe Jainism values along with Basic moral values into the children in the age group of 5 to 15 years.</p>

                                    <div className="call-media">
                                        <div className="media-icon"><i className="fas fa-phone-alt"></i></div>
                                        <div className="media-body">
                                            <span className="media-label">Contact Us</span>
                                            <p className="media-info"><a href={`tel:${this.state.themeSetting?.mobile}`} className="text-inherit">{this.state.themeSetting?.mobile}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape-mockup shapePulse d-none d-hd-block about-lotus" data-bottom="40%" data-left="6%" style={{ width: 80 }}><img src={bluelotus} alt="shapes" /></div>
                    <div className="shape-mockup rotate d-none d-md-block" data-bottom="40%" data-right="6%"><img src={star} alt="shapes" /></div>
                </section>
                <section className="counter-section space-double" data-bg-src="assets/img/bg/counter.jpg" data-overlay="title" data-opacity="8">
                    <div className="container">
                        <div className="row gy-30 justify-content-between">

                            <div className="col-xl-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <img src={counter3} alt="icon" />
                                    </div>
                                    <div className="counter-info">
                                        <h2 className="counter-number" data-target="4">0</h2>
                                        <p className="counter-text">No Of Locations</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <img src={counter4} alt="icon" />
                                    </div>
                                    <div className="counter-info">
                                        <h2 className="counter-number" data-target="1300">
                                            <span className="counter">0</span>
                                        </h2>
                                        <p className="counter-text">No of Students</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <img src={counter} alt="icon" />
                                    </div>
                                    <div className="counter-info">
                                        <h2 className="counter-number" data-target="160">
                                            <span className="counter" >0</span>
                                        </h2>
                                        <p className="counter-text">No Of Teachers</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="section-before style-2"><img src={counterbefore} alt="shape" /></div>
                    <div className="section-after style-2"><img src={counterafter} alt="shape" /></div>


                </section>
                <section className="about-section space">
                    <div className="container">
                        <div className="row align-items-center gy-30">

                            <div className="col-lg-5 wow fadeInRight" data-wow-delay="0.1s">
                                <div className="text-center text-lg-start">
                                    <h2 className="sec-title big-title">CORE VALUES</h2>
                                    <p className="fs-md mb-30">
                                        For us, the most important thing is to have high moral values in life, and we make the students understand the same through various activities. We also help them understand the value of having high morals and teach them to follow the main message of the Jain religion, “Peace and Ahimsa (Non-violence),” in their lives. We also emphasize the value and importance of faith in God through our religious and social discourses.                                    </p>

                                    <p className="fs-md mb-30">
                                        Apart from the above, we also teach them about family values and the importance of obeying and respecting their elders and parents and being responsible citizens of the country who can benefit the nation with their morals and talents.                                    </p>

                                    <p className="fs-md mb-30">
                                        Apart from this, many activities such as Gahuli, singing, crafts, drawing, yoga, speech, debate, projects, research, science, history, geography, and personality development are organized for the overall development of the child.                                    </p>

                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
                                <div className="img-box-2">
                                    <img src={aboutus1} alt="photo" className="big-img" />
                                    <img src={aboutusvector} alt="photo" className="small-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape-mockup shapePulse d-none d-hd-block about-book" data-bottom="40%" data-left="6%" style={{ width: 80 }}><img src={bookfooter} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse d-none d-md-block" data-bottom="40%" data-right="6%" style={{ width: 50 }}><img src={prayingboy} alt="shapes" /></div>
                </section>
                <section className="about-section bg-smoke space ">
                    <div className="container">
                        <div className="row align-items-center gy-30">

                            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.1s">
                                <div className="text-center text-lg-start">
                                    <span className="sub-title"></span>
                                    <h2 className="sec-title big-title">Gurujis and Karyakartas</h2>
                                    <p className="fs-md mb-30">We feel proud to inform you that all the Gurujis as well as all the volunteers associated with the organization are giving their honorary services voluntarily. We have a team in which the majority of them are graduates and postgraduates; many are still in college pursuing their degrees. The graduate and postgraduate volunteers are currently working as business people, entrepreneurs, graphic designers, fashion designers, journalists, event planners, and teachers and working in the corporate sector as executives at different positions.</p>
                                    <p className="fs-md mb-30">Selection and training of Gurujis are done in a structured manner. Before being appointed as Gurujis, they have to go through proper training. We, after their interview and selection, initially give them 2 months' training for improving their teaching skills and also conduct a training session with them every week so that they can learn new things from each other and how they can improve more on their teaching skills. Our own team members look after the entire training of Gurujis right from interviews, training, and managing in- and out-of-school in well-organized and disciplined manners.</p>
                                    <p className="fs-md mb-30"> Karyakarta’s team's primary work is to take care of students while coming or leaving the school. Also, various programs such as Annual Day, Talent Showcase, Shashan Sthapana Divas, and Yatra Pravas are designed and planned by Karyakartas for the students throughout the year. We are pledged to inform you that we always participate in many Shashan events, such as Samuhik Rath Yatra, be it the Save Sikharji Save Giriraj Rally or any other Shashan seva activity.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
                                <div className="img-box-2">
                                    <img src={guruji} alt="photo" className="big-img" />
                                    <img src={aboutusvector} alt="photo" className="small-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape-mockup shapePulse d-none d-hd-block about-book" data-bottom="40%" data-left="6%" style={{ width: 80 }}><img src={bookfooter} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse d-none d-md-block" data-bottom="40%" data-right="6%" style={{ width: 50 }}><img src={blassedguruji} alt="shapes" /></div>
                </section>
                <Footer />
            </React.Fragment>
        );
    }
}

export default AboutUs;
